module.exports = __webpack_public_path__ + "img/frances.56339cff.svg";